import React from 'react';

import Header from 'components/shared/Header';
import { toFriendlyDateTimeString } from 'helpers/Formatter';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

export default ({ log }) => {
  return (
    <div>
      <Header name="DETAILS" />
      <div className="row">
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Reported By</h5>
          <p>{log.reported_by}</p>
        </div>
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Log Type</h5>
          <p>{log.log_type_friendly}</p>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Date Created</h5>
          <p>{log.created_at ? toFriendlyDateTimeString(log.created_at) : 'N/A'}</p>
        </div>
      </div>

      <Header name="LOCATION" />
      <div className="row">
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Property</h5>
          <p>{log.property_name}</p>
        </div>

        {log.unit_name && (
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>Unit</h5>
            <p>{log.unit_name}</p>
          </div>
        )}
      </div>

      {log.lead_friendly && (
        <div className="row">
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              <TenantResidentVerbiageHelper capitalize />
            </h5>
            <p>{log.lead_friendly}</p>
          </div>
        </div>
      )}

      <div className="row" style={{ marginTop: '20px' }}>
        <div className="col-sm-12">
          <h5 style={{ marginBottom: '2px' }}>Details</h5>
          <p>{log.details}</p>
        </div>
      </div>
    </div>
  );
};
